export enum Roles {
  basfUser = "ROLE_USER",
  distributor = "ROLE_DISTRIBUTOR",
}
